import React, { useState } from "react";
import { ShieldCheck, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// Dismissible safe-trade tips banner shown on product detail + marketplace chats.
export default function SafeTradeBanner({ storageKey = "rc_safetrade_dismissed", testid = "safe-trade-banner", className = "" }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(() => localStorage.getItem(storageKey) !== "1");
  if (!open) return null;
  const dismiss = () => { localStorage.setItem(storageKey, "1"); setOpen(false); };
  const tips = [t("safe_tip_1"), t("safe_tip_2"), t("safe_tip_3"), t("safe_tip_4")];
  return (
    <div data-testid={testid} className={`rounded-2xl border border-[var(--rc-gold)]/30 bg-[var(--rc-gold)]/5 p-3 ${className}`}>
      <div className="flex items-start gap-2.5">
        <ShieldCheck size={18} className="text-[var(--rc-gold)] shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-[var(--rc-gold)]">{t("safe_trade_title")}</div>
          <ul className="mt-1 space-y-0.5 text-xs text-[var(--rc-muted)] list-disc list-inside">
            {tips.map((tip, i) => <li key={i}>{tip}</li>)}
          </ul>
        </div>
        <button onClick={dismiss} data-testid="safe-trade-dismiss" className="text-[var(--rc-muted)] hover:text-[var(--rc-text)] shrink-0"><X size={16} /></button>
      </div>
    </div>
  );
}
